const en = {
  common: { languageEs: "ES", languageEn: "EN", brand: "Equestrian Partners" },
  nav: { book: "Start" },
  blog: {
    metaTitle: "Blog · Equestrian Partners", metaDesc: "Ideas, strategy and knowledge for the equestrian sector by Equestrian Partners.",
    eyebrow: "Journal", title: "Blog", subtitle: "Ideas, strategy and knowledge to turn the equestrian world into real businesses.",
    backHome: "Home", read: "Read article", empty: "No published articles yet.",
    notFound: "Article not found", allArticles: "All articles", faqTitle: "Frequently asked questions",
  },
  hero: {
    title: "Do you have an idea for the equestrian sector?",
    subtitle: "We turn it into a company.",
    tagline: "Equestrian Events · Ventures · Technology · AI",
    ctaPrimary: "Book strategic session",
    ctaSecondary: "Discover how we work",
  },
  statement: {
    title: "The equestrian sector still solves many problems the way it did twenty years ago.",
    subtitle: "We turn those problems into opportunities.",
    button: "Explore possibilities",
  },
  expertise: {
    overline: "Our advantage",
    title1: "We didn't learn the sector from the outside.",
    title2: "We've lived it from within.",
    intro: "For over two decades we have worked at practically every level of the equestrian industry.",
    roles: [
      "As athletes.",
      "As organizers.",
      "As entrepreneurs.",
      "As project developers.",
      "As advisors.",
      "As business builders.",
    ],
    outro: "That's why we see opportunities a conventional tech agency would never spot.",
  },
  opportunities: {
    overline: "Possibilities",
    title: "A vision of what we could build together.",
    items: [
      { title: "Performance Intelligence", desc: "AI to analyze sporting performance." },
      { title: "Broadcast Intelligence", desc: "AI to turn competitions into premium audiovisual experiences." },
      { title: "Stable Operations", desc: "Operations automation for equestrian centers." },
      { title: "Equestrian Commerce", desc: "New digital models to monetize knowledge, services and community." },
    ],
  },
  method: {
    overline: "The Equestrian Partners™ Method",
    title1: "We don't build more.",
    title2: "We build better.",
    chapter: "CHAPTER",
    steps: [
      { title: "Eliminate", body: "We question every assumption. We remove the unnecessary." },
      { title: "Simplify", body: "We reduce the problem to its essence." },
      { title: "Design", body: "We create the right solution." },
      { title: "Build", body: "We develop only what adds value." },
      { title: "Scale", body: "We turn the project into a business." },
    ],
  },
  product: {
    overline: "Core product",
    title: "Book a strategic session.",
    price: "60 minutes. €299.",
    subtitle: "You'll leave with total clarity about your project.",
    duringTitle: "During the session",
    during: [
      "We analyze the idea",
      "We detect opportunities",
      "We validate the market",
      "We design the product",
      "We define the MVP",
      "We identify risks",
      "We design monetization",
      "We estimate investment",
      "We design the roadmap",
    ],
    resultTitle: "The result",
    resultDesc: "Premium document delivered after the meeting.",
    chips: [
      "Product vision", "Value proposition", "Features", "Architecture",
      "Roadmap", "Monetization", "Estimated budget", "Risks", "Opportunities",
    ],
    book: "Book strategic session · €299",
  },
  faq: {
    overline: "FAQ",
    title: "Everything you need to know.",
    items: [
      { q: "What exactly do you do?", a: "We build apps, software, artificial intelligence, automations and new digital models for companies and professionals in the equestrian sector." },
      { q: "Do I need to know about technology?", a: "No. We translate your sector experience into a viable technological solution." },
      { q: "What happens during the strategic session?", a: "We run a private diagnostic session where we analyze the idea, the business model, the market, feasibility and the technology required. Afterwards we deliver a strategic blueprint." },
      { q: "What does the blueprint include?", a: "Project vision, features, recommended architecture, roadmap, cost estimate and strategic recommendations." },
      { q: "How much does the session cost?", a: "€299. The amount is authorized when you book and only captured after the meeting takes place." },
      { q: "Do you develop the project yourselves?", a: "Yes. We can handle everything from strategy to full development." },
      { q: "Do you work with clubs, federations and organizers?", a: "Yes. We work with entrepreneurs, companies, clubs, organizers, federations and investors in the equestrian sector." },
      { q: "Is the session online or in person?", a: "The session is held online, in a private 60-minute format." },
      { q: "What happens after the session?", a: "You receive your Equestrian Blueprint™ and, if you decide to move forward, we support you in the development and launch of the project." },
    ],
  },
  finalCta: {
    title: "The best companies in the sector started as an idea.",
    subtitle: "The difference is that someone decided to build them.",
    button: "Book strategic session · €299",
  },
  footer: {
    book: "Book strategic session",
    tagline: "Technology & Venture Builders for the Equestrian Industry.",
    navTitle: "Navigation",
    nav: { home: "Home", how: "How we work", session: "Strategic session", faq: "FAQ", blog: "Blog", contact: "Contact" },
    contactTitle: "Contact",
    legalTitle: "Legal",
    legal: { privacy: "Privacy Policy", cookies: "Cookie Policy", terms: "Terms & Conditions" },
    rights: "All rights reserved.",
    cookiePrefs: "Cookie preferences",
  },
  booking: {
    back: "Back",
    overline: "Strategic session",
    title: "Book your session.",
    subtitle: "60 minutes · €299. You'll leave with total clarity about your project.",
    name: "Name", namePh: "Your name",
    email: "Email", emailPh: "you@email.com",
    phone: "Phone", phonePh: "+34 ...",
    company: "Company (optional)", companyPh: "Your company name",
    idea: "Briefly describe your idea", ideaPh: "What do you want to build for the equestrian sector?",
    chooseDate: "Choose a date",
    chooseTime: "Choose a time",
    submit: "Continue to payment · €299",
    submitting: "Redirecting to payment…",
    secure: "Secure payment processed by Stripe.",
    errorRequired: "Please complete all required fields.",
  },
  payment: {
    checking: "Confirming your payment…",
    successTitle: "Session booked.",
    successBody: "Your strategic session is confirmed. We have authorized €299 on your card, but the amount is not charged now: we only capture it after the meeting takes place. We'll contact you by email to coordinate the details and you'll receive your Equestrian Blueprint™.",
    home: "Back to home",
    pendingTitle: "Processing payment",
    pendingBody: "Your payment is being processed. You'll receive a confirmation by email shortly.",
    errorTitle: "Payment could not be confirmed",
    errorBody: "Please try again or write to us if the problem persists.",
    retry: "Retry booking",
  },
  cookie: {
    title: "We use cookies",
    body: "We use cookies for site functionality, analytics and personalization. You can accept all, reject them or configure them. See our",
    policyLink: "Cookie Policy",
    customize: "Customize",
    reject: "Reject All",
    accept: "Accept All",
    prefsOverline: "Preferences",
    modalTitle: "Cookie settings",
    save: "Save selection",
    categories: [
      { title: "Necessary", desc: "Essential for the site to function. They cannot be disabled." },
      { title: "Functional", desc: "Allow us to remember your preferences and improve the experience." },
      { title: "Preferences", desc: "Store custom settings such as language or region." },
      { title: "Analytics", desc: "Help us understand how the site is used to improve it." },
      { title: "Marketing", desc: "Used to show relevant content and campaigns." },
    ],
  },
  legal: {
    back: "Back",
    updated: "Last updated: 2026",
    privacidad: {
      title: "Privacy Policy",
      blocks: [
        ["Data controller", "Equestrian Partners is the controller of the personal data you provide through this website. For any privacy inquiry you can write to us at contact@equestrianpartners.net."],
        ["Data we collect", "We collect the data you provide when booking a strategic session (name, email, phone, optional company and a description of your idea), as well as technical browsing data when you give your consent (analytics and marketing cookies)."],
        ["Purpose", "We use your data to manage the booking and payment of the session, provide the contracted service, prepare your Equestrian Blueprint™ and communicate with you. Technical data is used to improve the site and, with your consent, for marketing."],
        ["Legal basis", "Processing is based on the performance of the contract (booking and session), your consent (cookies and commercial communications) and our legitimate interest in improving our services."],
        ["Retention", "We keep your data for as long as necessary to provide the service and comply with our legal obligations. Afterwards it is deleted or anonymized."],
        ["Your rights", "You can exercise your rights of access, rectification, erasure, objection, restriction and portability by writing to contact@equestrianpartners.net. You may also lodge a complaint with the competent supervisory authority."],
        ["Processors and payments", "Payment is processed securely through Stripe, acting as a data processor under the GDPR. We do not store your card data."],
      ],
    },
    cookies: {
      title: "Cookie Policy",
      blocks: [
        ["What are cookies?", "Cookies are small files stored on your device while browsing. They allow the site to work, remember your preferences and, with your consent, measure and personalize the experience."],
        ["Categories we use", "Necessary (essential, always on), Functional (features and preferences), Preferences (custom settings), Analytics (usage measurement) and Marketing (relevant content and campaigns)."],
        ["Consent management", "On your first visit you can Accept All, Reject All or Customize by category. You can change your decision at any time from 'Cookie preferences' in the footer."],
        ["Compliance", "This site complies with the GDPR and European cookie regulations. No non-essential cookies are activated without your prior consent."],
      ],
    },
    terminos: {
      title: "Terms & Conditions",
      blocks: [
        ["Purpose", "These terms govern the use of the site and the booking of the Equestrian Partners strategic session."],
        ["The strategic session", "The session lasts 60 minutes and costs €299. After it takes place we deliver the Equestrian Blueprint™ document with the project analysis."],
        ["Payment and authorization", "When you book, Stripe securely authorizes the €299 amount on your card, but it is not charged at that time. We capture the payment manually only after the session takes place. If it is not captured, the authorization is released automatically according to Stripe's rules."],
        ["Cancellations", "If you need to reschedule or cancel, write to us at contact@equestrianpartners.net as early as possible and we'll find the best solution."],
        ["Intellectual property", "The site's content and the Equestrian Partners™ methodology are the property of Equestrian Partners. The delivered Equestrian Blueprint™ is for your use as agreed."],
        ["Liability", "The Equestrian Blueprint™ is a strategic advisory document; it does not constitute a guarantee of business results."],
        ["Applicable law", "These terms are governed by applicable Spanish and European law."],
      ],
    },
  },
  admin: {
    os: "BLUEPRINT MEETING OS",
    restricted: "Restricted access",
    emailPh: "Email", passwordPh: "Password",
    signIn: "Sign in",
    cases: "cases",
    selectCase: "Select a case",
    paid: "Paid", authorized: "Authorized (€299)", released: "Released", unpaid: "Unpaid",
    statusPending: "Payment pending", statusAuthorized: "Authorized", statusConfirmed: "Confirmed", statusReleased: "Released",
    capture: "Capture €299", release: "Release",
    idea: "The idea",
    aiQuestions: "AI-assisted questions",
    generate: "Generate",
    notes: "Session notes", notesPh: "Answers and observations during the call…",
    save: "Save",
    blueprint: "Equestrian Blueprint™",
    regenerate: "Regenerate",
    fieldEmail: "Email", fieldPhone: "Phone", fieldCompany: "Company", fieldDateTime: "Date / Time",
    logout: "Log out",
    toastCaptured: "Payment captured · €299 charged",
    toastReleased: "Authorization released",
    toastNotesSaved: "Notes saved",
    toastBlueprint: "Equestrian Blueprint™ generated",
    toastBlueprintErr: "Could not generate the blueprint",
    toastLoadErr: "Could not load the bookings",
    record: "Record meeting", recording: "Recording… stop", transcribing: "Transcribing…",
    structureTitle: "Real-time organization", structure: "Structure",
    sVision: "Vision", sProblem: "Problem", sSolution: "Solution", sMarket: "Market",
    sMonetization: "Monetization", sFeatures: "Features", sRoadmap: "Roadmap",
    sRisks: "Risks", sOpportunities: "Opportunities", sBudget: "Preliminary budget",
    sNextSteps: "Next steps", sMissing: "Missing information",
    toastTranscribed: "Audio transcribed and added to notes",
    toastStructured: "Information structured",
    toastRecordErr: "Could not access the microphone",
    sendBlueprint: "Send to client", sendingBlueprint: "Sending…",
    toastBlueprintSent: "Blueprint emailed to the client",
    toastBlueprintSentErr: "Could not send the Blueprint",
    reschedule: "Reschedule", rescheduling: "Rescheduling…",
    toastRescheduled: "Session rescheduled · email sent to client",
    toastRescheduleErr: "Could not reschedule",
    searchPh: "Search client or company…",
    tabUpcoming: "Upcoming", tabPast: "Past", tabAll: "All",
    noBookings: "No bookings",
    overview: "Overview", interview: "Interview", intelligence: "Intelligence", budgetTab: "Proposal",
    secClient: "Client profile", secInterview: "Interview", secAI: "AI structuring",
    secBudget: "Commercial proposal",
    pipelineTitle: "Project pipeline",
    stages: {
      lead: "Lead",
      meeting_booked: "Meeting booked",
      interview_done: "Interview done",
      blueprint_generated: "Blueprint generated",
      blueprint_delivered: "Blueprint delivered",
      budget_generated: "Budget generated",
      proposal_sent: "Proposal sent",
      project_approved: "Project approved",
      in_development: "In development",
    },
    audioSection: "Session audio", audioPlay: "Play recording", audioNone: "No recording in this session",
    budgetPh: "Project scope, cost estimate, phases and terms…",
    budgetSave: "Save proposal", toastBudgetSaved: "Proposal saved",
    blueprintEdit: "Edit", blueprintEditPh: "The Blueprint will appear here. You can edit it before sending…",
    toastBlueprintSaved: "Blueprint saved",
    exportMd: "Download", exportPdf: "PDF", printBtn: "Print",
    stageSaved: "Stage updated",
    contactBtn: "Write email",
    navNewClient: "New client", navMeetings: "Meetings", navGrowth: "Growth OS",
    navKnowledge: "Knowledge OS", navSearch: "Search",
    growth: "Growth", secGrowth: "Growth plan (Growth OS)",
    growthIntro: "Generate an actionable growth plan grounded in the Business Reasoning Engine, with no time planning.",
    growthPh: "The growth plan will appear here. You can edit it before sharing…",
    toastBudgetGen: "Budget proposal generated",
    toastGrowthGen: "Growth plan generated", toastGrowthSaved: "Growth plan saved",
    toastClientCreated: "Client created",
    ncTitle: "New client", ncName: "Name", ncEmail: "Email", ncPhone: "Phone",
    ncCompany: "Company", ncIdea: "Idea / Business", ncOrigin: "Client origin",
    ncDate: "Date", ncTime: "Time", ncCreate: "Create client", ncCancel: "Cancel",
    ncSector: "Sector / Industry", ncSectorPh: "Select a sector…",
    ncBriefing: "Client briefing",
    ncBriefingHint: "Permanent client context. The AI studies it before generating questions, analysis, blueprint and budget.",
    ncBriefingPh: "Paste research, website, business model, history, financials, news, risks, detected problems, notes, summarized PDFs…",
    secBriefing: "Client briefing",
    briefingHint: "Permanent context. All AI (questions, intelligence, blueprint, budget) uses it automatically.",
    toastBriefingSaved: "Briefing saved",
    origins: {
      website: "Website", manual: "Manual", referral: "Referral", event: "Event",
      personal_contact: "Personal contact", network: "Network", linkedin: "LinkedIn", other: "Other",
    },
    koTitle: "Knowledge OS", koSubtitle: "Knowledge core of the Business Reasoning Engine",
    koCore: "System core", koIndustries: "Industry Knowledge Packs", koKb: "Knowledge base",
    koEvidence: "Evidence & traceability", koIndexed: "Indexed", koChunks: "chunks",
    koNotIndexed: "Not indexed", koVersion: "Version", koEdit: "Edit", koSave: "Save changes",
    koReindex: "Reindex all", koReindexed: "Reindex complete",
    koMaster: "Master Blueprint Framework", koManual: "Business Reasoning Manual",
    koFramework: "Reasoning constitution", koMethod: "Reasoning method",
    koSaved: "Document saved and indexing", koChangeSummary: "Change summary (optional)",
    koNewPack: "New pack", koPackName: "Pack name", koActive: "Active", koInactive: "Inactive",
    koContent: "Content", koNoIndustries: "No Industry Knowledge Packs yet.",
    koNoKb: "No knowledge base entries yet.", koTitleField: "Title",
    koNoEvidence: "No evidence records yet.",
    ksTitle: "Knowledge search", ksSubtitle: "Hybrid retrieval (BM25 + embeddings) with reranking",
    ksPlaceholder: "Ask the reasoning engine's knowledge…", ksSearch: "Search",
    ksNoResults: "No results. Try another query.", ksScore: "score", ksVec: "vector", ksBm: "lexical",
    originAll: "All origins", context: "Context", secContext: "Project context",
    contextIntro: "Reasoning context automatically retrieved for this client (Business Reasoning Engine).",
    contextEmpty: "No context yet. It is generated when you structure the session intelligence.",
    refresh: "Refresh", delete: "Delete", deleteConfirm: "Permanently delete this client?",
    confirmTitle: "Confirm action", confirmCancel: "Cancel", confirmDelete: "Delete",
    mlDeleteConfirm: "Permanently delete this image?",
    intSectorDelConfirm: "Delete this sector?", intSignalDelConfirm: "Delete this signal?",
    koDeleteConfirm: "Delete this knowledge pack?",
    blogPublishedNoHero: "Article published, but the hero image could not be generated. You can add one from the editor.",
    toastDeleted: "Client deleted",
    goTitle: "Growth OS", goSubtitle: "Equestrian Partners growth strategy (internal module)",
    goIntro: "Internal module to develop the growth, acquisition and promotion strategy of Equestrian Partners as a company. It is not tied to any client.",
    goPh: "The company growth strategy will appear here. You can edit it freely…",
    goEmpty: "No strategy yet. Generate a first draft with AI or write it manually.",
    goBack: "Back",
    navMedia: "Media Library", mlSubtitle: "Image library and visual identity engine",
    mlLibrary: "Library", mlIdentity: "Visual identity",
    mlPrompt: "Image description", mlPromptPh: "E.g.: PRE horse in an arena at sunset…",
    mlNoSector: "No sector (default preset)", mlGenerate: "Generate", mlUpload: "Upload",
    mlEmpty: "No images yet. Generate or upload the first one.",
    mlGenerated: "Image generated", mlUploaded: "Image uploaded", mlGenError: "Could not generate the image",
    mlPresetFor: "Preset for", mlDefaultPreset: "Default (global)", mlIdentitySaved: "Visual identity saved",
    vi_style: "Aesthetic / style", vi_photography: "Photography type", vi_lighting: "Lighting",
    vi_environment: "Environment", vi_people: "People", vi_wardrobe: "Wardrobe", vi_colors: "Color palette", vi_extra: "Extra directions",
    go_strategy: "Strategy", go_studio: "Content Studio", go_pipeline: "Pipeline", go_intelligence: "Intelligence", go_blog: "Blog",
    pipePublishHint: "This status is internal to the pipeline. To publish on the public blog use \"Send to Blog\" and publish it from the Blog tab.",
    intAllSectors: "All sectors", intQueryPh: "Query / angle to explore (optional)…",
    intScan: "Scan", intScanning: "Scanning…", intNeedSource: "Select at least one source",
    intScanDone: "Scan complete", intNoData: "No signals found. Try another query.",
    intScanningHint: "Crawling the web in real time and analyzing opportunities. This can take up to a minute…",
    intSectors: "Equestrian sectors", intNewSectorPh: "New sector…", intAddSector: "Add",
    intSectorAdded: "Sector added", intEmpty: "No signals yet. Run a scan to discover opportunities.",
    intComp: "Competition", intScores: "View scores", intSeo: "SEO", intCommercial: "Commercial", intTrend: "Trend",
    intSendPipeline: "Send to pipeline", intSentPipeline: "Opportunity sent to pipeline",
    navBrief: "Daily Brief",
    dbTitle: "Daily Brief", dbSubtitle: "Equestrian Partners daily editorial intelligence report",
    dbGenerate: "Generate brief", dbGenerating: "Generating…", dbGenerated: "Brief generated",
    dbHistory: "History", dbNoHistory: "No previous briefs yet.",
    dbEmpty: "No brief yet. Generate the daily report to see trends, opportunities, hooks and alerts.",
    dbTrends: "Trends", dbOpportunities: "Opportunities", dbHooks: "Hooks", dbAlerts: "Alerts",
    dbCopied: "Hook copied",
    koBlog: "Blog",
    blogTotal: "Total", blogPublished: "Published", blogDrafts: "Drafts", blogLanguages: "Languages",
    blogSearchPh: "Search articles…", blogAllStatus: "All statuses", blogAllLangs: "All languages",
    blogPublishedS: "Published", blogDraftS: "Draft", blogNew: "New article",
    blogEmpty: "No articles yet. Create the first one.", blogUntitled: "(untitled)",
    blogPublish: "Publish", blogUnpublish: "Unpublish", blogPublishedT: "Article published",
    blogUnpublished: "Article unpublished", blogDuplicated: "Article duplicated", blogDeleted: "Article deleted",
    blogDeleteConfirm: "Permanently delete this article?",
    blogBack: "Back to list", blogGenerate: "Generate with AI", blogGenerated: "Draft generated with AI",
    blogNeedTitle: "Title is required", blogNeedTopic: "Write a title/topic to generate", blogSaved: "Article saved",
    blogTitle2: "Title", blogSlug: "Slug (URL)", blogLang: "Language", blogStatus: "Status", blogExcerpt: "Excerpt",
    blogHero: "Hero image", blogHeroPh: "Describe the hero image…", blogHeroGen: "Generate", blogHeroUpload: "Upload",
    blogHeroSet: "Hero set", blogContent: "Content (Markdown)",
    blogPublishingHero: "Publishing: generating the hero image…", blogHeroError: "Could not generate the hero image; upload one manually and try again", blogHeroTimeout: "The hero image is taking longer than usual; reload in a few seconds",
    blogMetaTitle: "Meta title", blogMetaDesc: "Meta description", blogMetaKw: "Meta keywords",
    blogFaqAdd: "Add question", blogFaqQ: "Question", blogFaqA: "Answer",
    blogCtaLabel: "Button text", blogCtaUrl: "Button URL", blogCtaText: "CTA phrase",
    blogTranslation: "Translation / multi-language", blogTranslationHint: "Link this article to its version in the other language to auto-switch on the public site.",
    blogLinkPick: "Pick an article to link…", blogLink: "Link", blogUnlink: "Unlink",
    blogLinked: "Translation linked", blogUnlinked: "Translation unlinked",
    blogAiTranslate: "AI translation", blogAiTranslateHint: "Generate native versions of this article in other languages. They are created as linked drafts you can review before publishing.",
    blogTranslateTo: "Translate to", blogTranslateAll: "Translate to all languages",
    blogTranslateStarted: "{n} translation(s) in progress — they will appear as drafts in a few seconds",
    blogTranslateNone: "Versions already exist in all languages", blogTranslatingBadge: "Translating…",
    blogBulkTranslate: "Translate entire blog", blogBulkGo: "Translate & publish",
    blogBulkConfirm: "All published articles will be automatically translated to any missing languages (EN, ES, FR, DE, IT, PT) and published when ready. You can edit any translation afterwards. Continue?",
    blogBulkStarted: "{n} translations in progress — they will be published automatically when ready",
    blogTrTitle: "Translate article", blogTrHint: "The original language is never translated again. Pick the target languages.",
    blogTrOriginalTag: "Original", blogTrDoneTag: "Translated",
    blogTrSelectAll: "Select missing", blogTrAutoPublish: "Publish when ready",
    blogTrSubmit: "Translate",
    csTopic: "Topic / angle", csTopicPh: "E.g.: how to choose your first dressage horse without mistakes…",
    csNeedTopic: "Write a topic or angle first",
    csHooks: "Hooks", csScript: "Script", csVisual: "Visual direction", csImage: "Generate image",
    csAddPipeline: "Add to pipeline", csAdded: "Piece added to pipeline",
    cs_problem: "Problem", cs_consequence: "Consequence", cs_solution: "Solution", cs_body: "Content", cs_cta: "Call to action",
    fmt_reel: "Reel", fmt_carrusel: "Carousel", fmt_post: "Post", fmt_story: "Story", fmt_newsletter: "Newsletter",
    fmt_articulo: "SEO article", fmt_landing: "Landing", fmt_video: "Video script", fmt_email: "Email",
    st_idea: "Idea", st_draft: "Draft", st_ready: "Ready", st_published: "Published",
    pipeGenerating: "Generating…", pipeGenerated: "Content generated", pipeRegenerate: "Regenerate",
    pipeGenFor: "Generate", pipeToBlogBtn: "Publish to Blog", pipeToBlog: "Article sent to Blog (draft)",
    pipeInBlog: "In the Blog",
    blogScheduled: "Scheduled", blogArchived: "Archived", blogScheduledS: "Scheduled", blogArchivedS: "Archived",
    blogArchive: "Archive",
    blogSchedule: "Schedule publishing", blogScheduleBtn: "Schedule", blogNeedDate: "Pick a date and time",
    blogScheduledT: "Article scheduled",
    blogScheduleHint: "Save the article first. It will auto-publish at the chosen date.",
    blogInternalLinks: "Internal links", blogAddLink: "Add link", blogLinkText: "Link text",
    pipeAllStatus: "All statuses", pipeAllSectors: "All sectors",
    pipeEmpty: "No pieces yet. Create them from the Content Studio.",
    pipeEdit: "Edit piece", pipeDuplicated: "Piece duplicated", pipeDeleted: "Piece deleted",
    pipeSaved: "Piece saved", pipeDeleteConfirm: "Permanently delete this piece?",
  },
};

export default en;
